export default {
    clear() {
        sessionStorage.clear();
    },
    set(obj, val) {
        if (typeof(obj) == 'object') {
            Object.keys(obj).forEach(function(key, i) {
                sessionStorage.setItem(key, obj[key]);
            })
        } else if (val != undefined) {
            sessionStorage.setItem(obj, val);
        } else {
            parseInt("$session.setList 参数错误");
        }
    },
    get(key) {
        return sessionStorage.getItem(key);
    },
    // 静态不可变值
    orgName: sessionStorage.getItem('orgName'),
    orgIntroduce: sessionStorage.getItem('orgIntroduce'),
    //每次读取实时查询
    orgSendCount(num = 0) {
        let val = parseInt(this.get('orgSendCount'));
        if (num != 0) {
            val += num;
            val = Math.max(val, 0);
            sessionStorage.setItem('orgSendCount', val);
        }
        return val;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/session.js
// module id = null
// module chunks = 